<template>
  <div
    style="
      margin: 5% auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    ">
    <div style="height: 15vw; width: 15vw">
      <img src="@/assets/logo.png" alt="" style="width: 100%; height: 100%" />
    </div>
    <div class="login">
      <h1>做新能源生意，就上全球能</h1>
      <form @submit.prevent="handleSubmit">
        <div>
          <label for="tel">手机号：</label>
          <input type="text" v-model="tel" id="tel" required />
        </div>
        <div>
          <label for="pwd">密码：</label>
          <input type="password" v-model="pwd" id="pwd" required />
        </div>
        <button type="submit">登录</button>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </form>
    </div>
<!--    <div style="display: flex; margin-top: 1vw">
      <div>默认账号：18888888888；</div>
      <div>默认密码：123123</div>
    </div> -->
  </div>
</template>

<script>
import instance from "../utils/request.js";
export default {
  data() {
    return {
      tel: "18888888888",
      pwd: "123123",
      errorMessage: "",
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.tel || !this.pwd) {
        this.errorMessage = "请输入用户名和密码";
        return;
      }

      try {
        const response = await instance.post("/ApiIndex/loginsub", {
          tel: this.tel,
          pwd: this.pwd,
          logintype: 1,
        });
        console.log("adsdasdf", response);
        // 假设服务器返回的成功标志是 res.data.success
        if (response.status == 1) {
          localStorage.setItem("token", JSON.stringify(response.socket_token));
          this.$router.push({ name: "home" }); // 登录成功后跳转到主页
          // alert("登录成功");
          this.$message({
            message: "登录成功",
            type: "success",
          });
        } else {
          // this.errorMessage = "登录失败，请检查您的用户名和密码";
          this.$message.error("登录失败，请检查您的用户名和密码");
        }
      } catch (error) {
        console.error("There was an error!", error);
        // this.errorMessage = "登录失败，请重试";
        this.$message.error("登录失败，请重试");
      }
    },
  },
};
</script>

<style scoped>
.login {
  width: 20vw;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  height: 15vw;
}

.login h2 {
  text-align: center;
  margin-bottom: 20px;
}

.login div {
  margin-bottom: 15px;
}

.login label {
  display: block;
  margin-bottom: 5px;
}

.login input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.login button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.login button:hover {
  background-color: #0056b3;
}

.error-message {
  color: red;
  font-size: 0.9em;
  margin-top: 10px;
}
</style>
